import { Component, OnInit } from '@angular/core';
import { SculptureForm } from '../_models/sculptureform';
import { SculptureFormService } from '../_services/sculptureform.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-apply-form',
  templateUrl: './apply-form.component.html',
  styleUrls: ['./apply-form.component.scss']
})
export class ApplyFormComponent implements OnInit {
  angForm: FormGroup;
  public responseFoto1: { dbPath: '' };
  public responseFoto2: { dbPath: '' };
  public responseFoto3: { dbPath: '' };
  public responseFoto4: { dbPath: '' };
  public responseFoto5: { dbPath: '' };
  public responseVideo1: { dbPath: '' };

  public foto1: string;
  public foto2: string;
  public foto3: string;
  public foto4: string;
  public foto5: string;
  public videoUrl: string;


  showMeBasvuru: boolean;
  showMeCheckBoxlar: boolean;
  showFormEksikAlan: boolean;
  showMeKvkk: boolean;
  showVideoVeGorselZorunlu: boolean;
  showMeBirHataOlustu: boolean;
  constructor(private sculptureFormService: SculptureFormService, protected router: Router, private fb: FormBuilder) {
    this.createForm();
    this.showFormEksikAlan = false;
    this.showMeCheckBoxlar = false;
    this.showVideoVeGorselZorunlu = false;
    this.showMeBirHataOlustu = false;
    // this.onCreate();

  }
  handleSelectedBasvuru($event) {
    if ($event.target.checked === true) {
      this.showMeBasvuru = true;
      // Handle your code
    }
    else {
      this.showMeBasvuru = false;
    }
  }
  handleSelectedKvkk($event) {
    if ($event.target.checked === true) {
      this.showMeKvkk = true;
      // Handle your code
    }
    else {
      this.showMeKvkk = false;
    }
  }

  public onCreate = () => {
    this.foto1 = this.responseFoto1.dbPath;
    this.foto2 = this.responseFoto2.dbPath;
    this.foto3 = this.responseFoto3.dbPath;
    this.foto4 = this.responseFoto4.dbPath;
    this.foto5 = this.responseFoto5.dbPath;
    this.videoUrl = this.responseVideo1.dbPath;
  }
  ngOnInit(): void {
    this.router.navigate(['/anasayfa']);
  }
  public uploadFinished1 = (event) => {
    this.responseFoto1 = event;
  }
  public uploadFinished2 = (event) => {
    this.responseFoto2 = event;
  }
  public uploadFinished3 = (event) => {
    this.responseFoto3 = event;
  }
  public uploadFinished4 = (event) => {
    this.responseFoto4 = event;
  }
  public uploadFinished5 = (event) => {
    this.responseFoto5 = event;
  }
  public uploadFinishedVideo = (event) => {
    this.responseVideo1 = event;
  }
  createForm() {
    this.angForm = this.fb.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', Validators.required],
      birthdate: ['', Validators.required],
      telefon1: ['', Validators.required],
      eseradi: ['', Validators.required],
      en: ['', Validators.required],
      boy: ['', Validators.required],
      derinlik: ['', Validators.required],
      malzeme: ['', Validators.required],
      agirlik: ['', Validators.required],
    });
  }

  applyForm(name: string, surname: string, email: string, birthdate: string, phone: string, website: string, address: string,
    attendedexhibitions: string, sculpturename: string, productiondate: string, width: string, height: string, depth:
      string, material: string, weight: string, definition: string) {

    if (!this.showMeKvkk || !this.showMeBasvuru) {
      this.showMeCheckBoxlar = true;
      console.log(name);
      console.log('bos alanları doldurmalisinxx');
      return;
    }
    else {

      this.showMeCheckBoxlar = false;
    }

    if (this.responseFoto1 === undefined || this.responseVideo1 === undefined) {
      this.showVideoVeGorselZorunlu = true;
      console.log('video ve resim zorunlu');
      return;
    }
    else {
      this.showVideoVeGorselZorunlu = false;
    }

    if (this.angForm.status != 'VALID') {
      this.showFormEksikAlan = true;
      console.log('bos alanları doldurmalisin');
      return;
    }

    this.foto1 = this.responseFoto1.dbPath;
    this.videoUrl = this.responseVideo1.dbPath;

    this.foto2 = '';
    this.foto3 = '';
    this.foto4 = '';
    this.foto5 = '';
    if (this.responseFoto2 !== undefined) {
      this.foto2 = this.responseFoto2.dbPath;
    }
    if (this.responseFoto3 !== undefined) {
      this.foto3 = this.responseFoto3.dbPath;
    }
    if (this.responseFoto4 !== undefined) {
      this.foto4 = this.responseFoto4.dbPath;
    }
    if (this.responseFoto5 !== undefined) {
      this.foto5 = this.responseFoto5.dbPath;
    }

    console.log(name);
    console.log(surname);
    console.log(email);
    console.log(birthdate);
    console.log(this.responseFoto1.dbPath)


    const model = new SculptureForm(name, surname, email, birthdate, phone, website, address, attendedexhibitions, sculpturename, productiondate, width,
      height, depth, material, weight, definition, this.videoUrl, this.foto1, this.foto2, this.foto3, this.foto4, this.foto5);
    this.sculptureFormService.applyNewSculptureForm(model).subscribe(() => {
      console.log("form oluşturuldu.");
      this.router.navigate(['/sonuc']);
    }, error => {
      console.log("hata, logları inceleyiniz..");
      console.log(error);
      this.showMeBirHataOlustu = true;


    });

  }

}